import React from 'react';
import Footer from 'components/Footer';

const TermsOfUse = () => {
  return (
    <div className="flex flex-col min-h-screen bg-gradient-to-b from-white to-blue-50">
      {/* Navigation Bar */}
      <nav className="bg-white/90 backdrop-blur-sm shadow-sm sticky top-0 z-50 transition-all duration-300">
        {/* Using the same NavBar structure as Home.js */}
        <div className="max-w-screen-xl flex flex-wrap items-center justify-between mx-auto p-4">
          <a href="/" className="flex items-center space-x-3 transform hover:scale-105 transition-transform duration-300">
            <img src="/logo3.png" className="h-10 md:h-14" alt="Logo" />
            <span className="self-center text-xl md:text-2xl font-semibold text-gray-800">ChemSafe</span>
          </a>
        </div>
      </nav>

      {/* Main Content */}
      <div className="container mx-auto px-4 py-12">
        <div className="max-w-4xl mx-auto bg-white rounded-2xl shadow-lg p-8 mb-12">
          <h1 className="text-4xl font-bold text-gray-900 mb-8">Terms of Use</h1>
          
          <div className="prose max-w-none">
            <section className="mb-8">
              <h2 className="text-2xl font-semibold text-gray-800 mb-4">Acceptance of Terms</h2>
              <p className="text-gray-600">
                By accessing and using the ChemSafe website and tools, you agree to be bound by these Terms of Use 
                and all applicable laws and regulations.
              </p>
            </section>

            <section className="mb-8">
              <h2 className="text-2xl font-semibold text-gray-800 mb-4">Use License</h2>
              <ul className="list-disc pl-6 text-gray-600 space-y-2">
                <li>The content on this website is for research and educational purposes only</li>
                <li>Tools and resources are provided as-is without any warranties</li>
                <li>Usage of tools requires acknowledgment of IIT Madras research contribution</li>
              </ul>
            </section>

            <section className="mb-8">
              <h2 className="text-2xl font-semibold text-gray-800 mb-4">Disclaimer</h2>
              <p className="text-gray-600">
                The tools and information provided are for research purposes and should not be considered as 
                a replacement for professional safety consultation. Users should exercise their own judgment 
                and comply with all applicable safety regulations.
              </p>
            </section>

            <section className="mb-8">
              <h2 className="text-2xl font-semibold text-gray-800 mb-4">Intellectual Property</h2>
              <p className="text-gray-600">
                All content, tools, and resources on this website are the property of IIT Madras and protected 
                by intellectual property laws.
              </p>
            </section>

            <section className="mb-8">
              <h2 className="text-2xl font-semibold text-gray-800 mb-4">Contact</h2>
              <p className="text-gray-600">
                For any questions regarding these terms, please contact:{' '}
                <a href="mailto:chemsafe.iitm@gmail.com" className="text-blue-600 hover:text-blue-800">
                  chemsafe.iitm@gmail.com
                </a>
              </p>
            </section>
          </div>
        </div>
      </div>
      <Footer />
    </div>
  );
};

export default TermsOfUse;
